'use client';

import React from 'react';
import { CustomButton } from '@/components/ui/CustomButton';

export const FCALookupSection = ({
  formData,
  handleInputChange,
  handleFcaIdChange,
  lookupState,
  handleFcaLookup,
  errors,
}) => {
  return (
    <>
      <label htmlFor="fcaId" className="text-[#373945] text-base font-medium mb-2 block">
        Your Firm FCA number
      </label>

      <div className="mb-6">
        <div className="relative">
          <input
            type="text"
            id="fcaId"
            name="fcaId"
            value={formData.fcaId}
            onChange={(e) => handleInputChange(handleFcaIdChange(e))}
            placeholder="Enter valid FCA number"
            min="100000"
            className={`w-full p-4 border rounded-lg focus:outline-none ${
              errors.fcaId
                ? 'border-2 border-[#D32F2F] focus:border-[#D32F2F] focus:ring-[#D32F2F]'
                : 'border-gray-300 focus:border-[#006EB7]'
            }`}
          />

          <CustomButton
            variant="primaryMedium"
            type="button"
            className={`absolute right-2 top-1/2 -translate-y-1/2 disabled:opacity-50 disabled:cursor-not-allowed${lookupState === 'done' ? ' hidden' : ''}`}
            disabled={!formData.fcaId || ['loading', 'done'].includes(lookupState)}
            onClick={handleFcaLookup}
            icon={() => (
              <img
                src={`/img/icons/${lookupState === 'loading' ? 'refresh-gray' : 'search-lg-gray'}.svg`}
                alt="Search"
                className={`w-5 h-5${lookupState === 'loading' ? ' animate-spin' : ''}`}
              />
            )}
          />
        </div>

        <div id="fcaError" className={`pt-2${lookupState !== 'error' ? ' hidden' : ''}`}>
          <p className="flex text-[#D0342C]">
            <img src="/img/icons/info-circle.svg" alt="Info" className="pr-2" />
            Invalid FCA Number
          </p>
        </div>
      </div>
    </>
  );
};
